import React from "react";
import { handleRenderReportStatus } from "../../utils/helpers";
import DateUtils from "src/services/utils/DateUtils";
import { INTERNATIONAL_DATE_FORMAT } from "src/common/constants";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { Button, UncontrolledTooltip } from "reactstrap";
import { isFeatureEnabledForActiveModule } from "src/helpers/module_helper";
import { ROLE_ANALYST_ADMIN } from "src/components/constants";
import { toast } from "react-toastify";
import { routes } from "../../data";

const dateUtils = new DateUtils();

const restrictedRoles = [ROLE_ANALYST_ADMIN];

export const getTableColumns = ({
    t,
    userUtils,
    setUserIdToDelete,
    updateUserStatusHandler,
    user,
    activeModule,
    setUserIdToSendEmail
}) => [
    {
        key: 1,
        dataField: "gender",
        text: t("Salutation"),
        sort: true,
        style:{
            width : '60px'
        }
    },
    {
        key: 2,
        dataField: "firstName",
        text: t("First Name"),
        sort: true,
        style:{
            width : '120px'
        },
        formatter: (_cellContent, { first_name }) => {
            return first_name
        }
    },
    {
        key: 3,
        dataField: "firstName",
        text: t("Last Name"),
        sort: true,
        style:{
            width : '120px'
        },
        formatter: (_cellContent, { last_name }) => {
            return last_name
        }
    },
    {
        key: 4,
        dataField: "email",
        text: t("Email"),
        style: {
            width: "200px",
        },
        sort: true,
    },
    {
        key: 5,
        dataField: "position",
        style: {
            width: "80px"
        },
        text: t("Position"),
        sort: true
    },
    // {
    //     key: 7,
    //     dataField: "division",
    //     text: `${t("Division")}`,
    //     formatter: (cellContent) => {
    //         return <div>{cellContent?.division_name}</div>;
    //     },
    //     style: {
    //         width: "120px"
    //     },
    //     sort: true
    // },
    {
        key: 8,
        dataField: "department",
        text: `${t("Division")}`,
        formatter: (cellContent) => {
            return <div>{cellContent}</div>;
        },
        style: {
            width: "120px"
        },
        sort: true
    },
    {
        key: 9,
        dataField: "roles",
        text: t("Assigned Role"),
        sort: false,
        style: {
            width: "120px"
        },
        formatter: (cellContent, row) => {
            return (
                <div>
                {row.roles
                    .map((i) => t(userUtils.moduleRoles(activeModule, i)))
                    .join(", ")}
                </div>
            );
        }
    },
    {
        key: 10,
        dataField: "createdAt",
        sort: true,
        text: t("Created On"),
        style: {
            width: "100px"
        },
        formatter: (_cellContent, { created_at }) => {
            return (
                <div>
                    {dateUtils.convertTimeStampToDate(
                        created_at,
                        INTERNATIONAL_DATE_FORMAT
                    )}
                </div>
            );
        }
    },
    {
        key: 11,
        dataField: "updatedAt",
        sort: true,
        text: t("Updated On"),
        style: {
            width: "100px"
        },
        formatter: (_cellContent, { updated_at }) => {
            return (
                <div>
                    {dateUtils.convertTimeStampToDate(
                        updated_at,
                        INTERNATIONAL_DATE_FORMAT
                    )}
                </div>
            );
        }
    },
    {
        key: 12,
        dataField: "status",
        text: t("Status"),
        style: {
            width: "80px"
        },
        formatter: (cellContent, row) => {
            return (
                <div>
                    {handleRenderReportStatus({
                        status: row.status,
                        user: row,
                        updateUserStatusHandler,
                        t,
                    })}
                </div>
            );
        }
    },
    {
        key: 13,
        dataField: "edit",
        text: t("Actions"),
        style: {
            width: "200px"
        },
        formatter: (cellContent, row) => {
            const isAccessDeniedForEdit =
                !userUtils.isSuperAdmin(user) &&
                row.roles.some((role) => restrictedRoles.includes(role));

            const handleClick = (e) => {
                e.preventDefault();
                toast.error(t("Access denied"));
            };

            return (
                <div>
                    {!row?.roles?.includes("ROLE_THIRD_PARTY") && 
                    (
                        <Link
                            className="waves-effect btn btn-link"
                            to={routes[activeModule].editUser(row.id)}
                            onClick={isAccessDeniedForEdit ? handleClick : null}
                        >
                            <i className="ri-edit-2-fill"></i>
                        </Link>
                    )}

                    {!row.show_activate_button && (
                        <>
                            <Button
                                color="link"
                                className="waves-effect"
                                id={`resend-email-button-${row.id}`}
                                onClick={() => {
                                    setUserIdToSendEmail(row.id)
                                }}
                            >
                                <i className="ri-mail-send-line"></i>
                            </Button>

                            <UncontrolledTooltip
                                target={`resend-email-button-${row.id}`}
                            >
                                {t('Resend invitation email so this user can set their password and access the platform.')}
                            </UncontrolledTooltip>
                        </>
                    )}

                    {isFeatureEnabledForActiveModule("delete-user") && (
                        <Button
                            onClick={() =>
                            isAccessDeniedForEdit
                                ? toast(t("Access denied"), {
                                    type: "error",
                                })
                                : setUserIdToDelete(row.id)
                            }
                            color="link"
                            className="waves-effect  text-danger"
                        >
                            <i className="ri-delete-bin-fill"></i>
                        </Button>
                    )}
                </div>
            )
        }
    }
];
